export default __webpack_public_path__ + "static/media/NCCostaRica.6f0546e2.png";